import { get } from 'jquery'
import { axiosAjax } from './common'

export default {
  // get current online connect count
  getOnlineConnectCount (params) {
    return axiosAjax('/v1/tunnel_connection/count', 'get', {params: params})
  },
  // load current online connect list
  getOnlineConnectList (params) {
    return axiosAjax('/v1/tunnel_connection/list', 'get', {params: params})
  },
  // cut online
  cutOnlineConnent (id) {
    return axiosAjax('/tunnel_connection/' + id, 'delete')
  },
  // cut online multiple
  cutOnlineConnentMultiple (params) {
    return axiosAjax('/tunnel_connection/delete_all', 'post', {data: params})
  },
  // get statistic
  getStatistics (params) {
    return axiosAjax('/v1/summary', 'get', {params: params})
  },
  // get top members 接口优化为_v1版本
  getTopMembers (params) {
    // return axiosAjax('/statistic/account', 'get', {params: params})
    return axiosAjax('/statistic/account_v1', 'get', {params: params})
  },
  // get top resources 接口优化为_v1版本
  getTopResources (params) {
    // return axiosAjax('/statistic/resource', 'get', {params: params})
    return axiosAjax('/statistic/resource_v1', 'get', {params: params})
  },
  // get connect numbers
  getConnectNumbers (params) {
    return axiosAjax('/connect/numbers', 'get', {params: params})
  },
  // 获取一周运维统计 接口优化为_v1版本
  getWeekOperationStatistic (params) {
    // return axiosAjax('/statistic/overview', 'GET', {params: params})
    return axiosAjax('/statistic/overview_v1', 'GET', {params: params})
  },
  // 获取资源类型统计
  getResourceTypeStatistic (params) {
    return axiosAjax('/instances_summary', 'GET', {params: params})
  },
  // 获取统计概览
  getStatisticSummary (params) {
    return axiosAjax('/statistic/summary', 'GET', {params: params})
  },
}



// WEBPACK FOOTER //
// ./src/api/dashboard.js